import { fetchWithOrganization } from "./organizationRequest";

function normalizeBaseUrl(url) {
    return String(url || "").trim().replace(/\/$/, "");
}

const CALENDAR_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_CALENDAR_BASE_URL || "http://localhost:8087");

async function requestJson(baseUrl, path, options = {}) {
    const response = await fetchWithOrganization(`${normalizeBaseUrl(baseUrl)}${path.startsWith("/") ? path : `/${path}`}`, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        ...options,
    });

    let payload = {};
    try {
        payload = await response.json();
    } catch {
        payload = {};
    }

    if (!response.ok) {
        const errorMessage = payload?.error || payload?.message || `Request failed (${response.status})`;
        const error = new Error(errorMessage);
        error.status = response.status;
        error.payload = payload;
        throw error;
    }

    return payload;
}

export function getAttributeSelectionIds(attributeSelection = {}) {
    const selections = Object.values(attributeSelection).filter((selection) => selection && typeof selection === "object");

    return {
        attributeIDs: [...new Set(
            selections.map((selection) => Number(selection.attribute_id)).filter((id) => Number.isFinite(id) && id > 0),
        )],
        attributeValueIDs: [...new Set(
            selections.map((selection) => Number(selection.attribute_value_id)).filter((id) => Number.isFinite(id) && id > 0),
        )],
    };
}

// services: [{ product_id, appointment_attributes: { [name]: { attribute_id, attribute_value_id } } }]
export function buildFollowUpPayload({
    userID,
    customerID,
    date,
    startTime,
    endTime,
    services = [],
}) {
    return {
        user_id: Number(userID || 0),
        product_id: Number(services[0]?.product_id || 0),
        customer_id: Number(customerID || 0),
        date,
        start_time: startTime,
        end_time: endTime,
        status: "PENDING",
        services,
    };
}

export async function fetchFollowUpAvailability(month, duration, startDate, userID) {
    return requestJson(CALENDAR_BASE_URL, "/calendar/availability/index", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            user_id: String(userID ?? ""),
            month,
            duration: Number(duration),
            start_date: startDate,
        }),
    });
}

export async function createFollowUpAppointment(payload) {
    return requestJson(CALENDAR_BASE_URL, "/calendar/appointments/followUp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
}
